
import { survicateConfig } from './config/config';
import { Task } from './interfaces/survicate.interface';
import { SurvicateTaskType } from './enums/survicate.enum';
import { SurvicateService } from './services/survicate.service';

export const sharedUtilSurvicate = self as any;

declare var window: any;
let initSurvicateDone: boolean = false;

const executeEventTask = function(task: Task): void {
  task.config.condition(task.name).then((result: boolean) => {
    if (result) {
      window[survicateConfig.survicateWindowString].invokeEvent(task.config.nameString);
      //console.log('Event triggered:', task.config.nameString);
    }
  });
}

const executeTask = function(task: Task): void {
  switch (task.config.type) {
    case SurvicateTaskType.Event:
      setTimeout(() => executeEventTask(task), survicateConfig.eventTriggerDelay); //delay for popups check
      break;
    //add more task types here
    default:
      break;
  }
}

const processTasks = function(tasks: Task[]): void {
  tasks.forEach((task: Task) => {
    executeTask(task);
  });
}

const initUtilSurvicate = function(): void {
  if (initSurvicateDone) {
    return;
  } else {
    const survicateService = SurvicateService.getInstance();
    if(survicateService.isSurvicateEnabled()) {
      processTasks(survicateConfig.tasks);
    } else {
      survicateService.clearSurvicateSessionStorage();
    }
    initSurvicateDone = true;
  }
}

window.addEventListener('SurvicateReady', initUtilSurvicate, false);
